
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class WormholeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const rings = Math.floor(20 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < rings; i++) {
                const z = ((i / rings) + curTime * 0.5) % 1;
                const r = z * Math.max(width, height) * 1.5 * scale;
                const alpha = (1 - z) * 0.6;
                
                ctx.save();
                ctx.globalAlpha = alpha / (layerIndex + 1);
                ctx.lineWidth = (2 + (1 - z) * 10) * scale;
                
                // Distorted ring
                ctx.beginPath();
                for (let a = 0; a < Math.PI * 2; a += 0.2) {
                    const noise = Math.sin(a * 5 + curTime * 2) * 20 * scale * z;
                    const px = Math.cos(a) * (r + noise);
                    const py = Math.sin(a) * (r + noise);
                    if (a === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                }
                ctx.closePath();
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
